var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3288 0.0380102C5.38385 0.0699256 5.42646 0.119567 5.44965 0.178825C5.47284 0.238083 5.47525 0.303455 5.45649 0.36426L4.44342 3.65601H6.31261C6.36754 3.65599 6.42128 3.67205 6.46718 3.70222C6.51309 3.73239 6.54916 3.77534 6.57093 3.82577C6.59271 3.8762 6.59924 3.9319 6.58972 3.986C6.5802 4.0401 6.55505 4.09023 6.51736 4.1302L2.01736 8.91145C1.97382 8.95775 1.91588 8.98794 1.85298 8.99709C1.79009 9.00624 1.72595 8.99383 1.67101 8.96186C1.61608 8.92989 1.5736 8.88026 1.55048 8.82105C1.52737 8.76184 1.52499 8.69655 1.54374 8.63582L2.5568 5.34351H0.687612C0.632681 5.34353 0.578946 5.32747 0.533041 5.2973C0.487135 5.26713 0.451068 5.22418 0.429293 5.17375C0.407517 5.12332 0.400986 5.06762 0.410506 5.01352C0.420026 4.95942 0.445179 4.90929 0.482862 4.86932L4.98286 0.0880727C5.02635 0.0418347 5.0842 0.0116675 5.14701 0.00247626C5.20982 -0.00671502 5.27389 0.00561013 5.3288 0.0374477V0.0380102Z",
    fill: "#192923"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightning);
export default __webpack_public_path__ + "static/media/icon_lightning.8883b2d594e7bf0f86138fde4908d425.svg";
export { ForwardRef as ReactComponent };